import Icon from '../components/Icon.vue'

Icon.register({"user-clock":{"width":640,"height":512,"paths":[{"d":"M496 224C416.4 224 352 288.4 352 368S416.4 512 496 512 640 447.6 640 368 575.6 224 496 224zM560 374.3C560 379.6 555.6 384 550.3 384H489.7C484.4 384 480 379.6 480 374.3V297.7C480 292.4 484.4 288 489.7 288H502.3C507.6 288 512 292.4 512 297.7V352H550.3C555.6 352 560 356.4 560 361.7V374.3zM320 368C320 340.2 326.7 313.9 338.2 290.5 330.2 289 322 288 313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H395.1C349.8 480.1 320 427.5 320 368zM224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-clock.js
// module id = F+Tn
// module chunks = 0